<template>
  <div><!--最外层DIV-->
    <div><!--内容DIV-->
      <div class="loginForm">
        <div style="width: 100%;height: 40px;background-color: #2d2d2d;margin: 0 auto;">
          <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: left;margin-left: 20px;">
            图片裁剪
          </span>
          <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: right;margin-right: 20px;">
            <a href="javascript:;" @click="close()">
              <i class="el-icon-close"></i>
            </a>
          </span>
        </div>
        <div style="width: 850px;margin: 0 auto;">
          <div style="width: 100%;overflow: hidden;margin-top: 15px;">
            <div style="width: 70%;float: left;margin-top: 10px;">
              <img :src="photo" ref="image" alt="">
            </div>
            <div style="width: 25%;float: left;margin-left: 4%;margin-top: 10px;">
              裁剪后的图片
              <br><br>
              <div class="bbbbb">

              </div>
            </div>
          </div>
          <div style="width: 100%;text-align: right;margin-top: 15px;">
            <el-button @click="close()">取消</el-button>
            <el-button @click="reimage()" type="warning">重置</el-button>
            <el-button @click="sureSava" type="primary">确认</el-button>
          </div>
        </div>
        <br>
      </div>
    </div>
  </div>
</template>

<script>
  import {commonAPI} from '@/api/commonAPI'
  import Cropper from 'cropperjs'
  import 'cropperjs/dist/cropper.css'
  export default {
    props: {
        div_name: {
          type: String,
          default: ''
        },
        img_date: {
          type: Object,
          default: null
        },
        width: {
          type: String,
          default: '1'
        },
        height: {
          type: String,
          default: '1'
        }
      },
    data() {
      return {
        myCropper: null,
        afterImg: '',
        photo:'',
        //变量
        interval:'',

        content:'',
        AddForm:{
          admin_id:'',
          title:'',
          content:'',
          message_id:'',
          enclosurecol_i_id:'',
        },
        //取消保存
        NoSave:{
          list:''
        },
        //回调数据
        returnes:{
          returns:'',
        },
      }
    },
    //页面开启时执行
    mounted(){
      //this.init();
      //
      //赋值
      //this.AddForm.admin_id=this.$store.state.a_id;
      //this.AddForm.enclosurecol_i_id="FJ"+(new Date()).valueOf();
    },

    watch: {
      'img_date': {
        handler(){
          this.photo=URL.createObjectURL(this.img_date.raw);
          //console.log(this.photo)
          this.interval=setInterval(()=>{
               this.init()
              },0)
        }
      }
    },

    methods: {
      //重置
      reimage(){
        this.myCropper.reset();
      },
      //
      init(){
        clearInterval(this.interval);
        //console.log("开始执行了")
        this.myCropper=null;
        if(this.photo==""){
          return false;
        }
        if(this.myCropper!=null){
          return false;
        }
        this.myCropper = new Cropper(this.$refs.image, {
          viewMode: 1,
          dragMode: 'none',
          initialAspectRatio: this.width*1/this.height*1,
          aspectRatio: this.width*1/this.height*1,
          preview: '.bbbbb',
          background: false,
          autoCropArea: 0.6,
          zoomOnWheel: false,
        })
      },
      sureSava(){
        this.afterImg = this.myCropper.getCroppedCanvas({
          imageSmoothingQuality: 'high'
        }).toDataURL('image/jpeg')
        //console.log(this.afterImg)
        this.test();
      },
      test(){
        let filename=new Date().getTime();
        var arr = this.afterImg.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        //this.photo1=URL.createObjectURL(new File([u8arr], filename, {type:mime}));
        //console.log(new File([u8arr], filename, {type:mime}))
        this.$emit('fatherMethod',new File([u8arr], filename, {type:mime}));
        this.close();
      },
      close(){
        this.photo="";
        document.getElementById(this.div_name).style.display='none';
        document.getElementById('zhedang').style.display='none';
        this.myCropper.destroy();
      },
    }
  }
</script>

<style scoped>
  /**登录框架*/
  .logindiv{
    position: fixed;
    top: 15%;
    left:0;
    right:0;
    bottom: 0;
    margin:0 auto;
    padding: 20px;
    border: 0px solid #ddd;
    z-index:2002;
    overflow: auto;
    text-align: center;
    display: none;
  }
  .loginForm{
    margin: 0 auto;
    width: 900px;
    max-height: 700px;
    background-color: #fff;
    -webkit-box-shadow: #333 0px 5px 5px;
    -moz-box-shadow: #333 0px 5px 5px;
    box-shadow: #333 0px 5px 5px;
  }
  .loginForm a{
    color: #fff;
  }
  .loginForm a:hover{
    color: #d6d6d6;
  }
  .bbbbb{
    height: 200px;
    overflow: hidden;
  }
  img{
    max-width: 100%;
    max-height: 500px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/img_update/images_UP.vue